import React from 'react'
import PropTypes from 'prop-types'
import {
  ActionLink,
  UserActionsWrapper,
  UserActionsButton,
  UserActionMenu,
  UserActionMenuItem,
} from './component.styles'

// TODO: Add some animations and also make the last menu
// open upward
const UserActions = ({ actions, email, areActionsOpen, toggleActions }) => {
  return (
    <UserActionsWrapper>
      <UserActionsButton
        data-testid={`user-actions-button-${email}`}
        onClick={toggleActions}
      >
        <i className="fas fa-ellipsis-h" />
      </UserActionsButton>
      {areActionsOpen && (
        <UserActionMenu>
          <React.Fragment>
            {actions.map(action => (
              <UserActionMenuItem key={action.text}>
                <ActionLink
                  data-testid={`user-actions-menu-item-${action.type}-${email}`}
                  onClick={action.handler}
                  type={action.type}
                >
                  {action.text}
                </ActionLink>
              </UserActionMenuItem>
            ))}
          </React.Fragment>
        </UserActionMenu>
      )}
    </UserActionsWrapper>
  )
}

UserActions.propTypes = {
  actions: PropTypes.array.isRequired,
  areActionsOpen: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  toggleActions: PropTypes.func.isRequired,
}

export default UserActions



// WEBPACK FOOTER //
// ./src/components/UserActions/component.js